export default __webpack_public_path__ + "media/images/mailer/icon_reply-1c00f97d10006dd420bc620b26a79d8a.png";